import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    rootContainer: {
        marginTop: "20px"
    },
    titleBlock: {
        display:"flex",
        alignItems:"center"
    },
    title:{
        fontWeight: "bold",
        fontSize: "14px"
    },
    addIcon: {
        marginLeft: "8px",
        cursor:"pointer"
    },
    tableHeaderCell:{
        // borderBottom:"none"
    },
    tableActions:{
        display:"flex",
        alignItems:"center"
    },
    actionIcon:{
        cursor:"pointer"
    }
}))

export default useStyles